import React from 'react';
import I18n from 'i18n-js';
import classNames from 'classnames';

import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { prefilledListingFromCSP } from '@reverbdotcom/commons/src/url_helpers';
import { CoreCspLayoutQuery } from '../schemas/rql';
import USD from '../../images/sell-flow/sell-your-gear.svg';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

interface IProps {
  csp: CoreCspLayoutQuery.Csp
  belowListing?: boolean;
}

export function SellYoursV4({ csp, belowListing }: IProps) {
  if (!csp) { return null; }

  const { id, title: cspTitle } = csp;

  if (!id || !cspTitle) { return null; }

  const trackingData = {
    componentName: 'SellYoursV4',
    eventName: MParticleEventName.ClickedSellYoursV4,
  };

  const backgroundImage = 'https://rvb-img.reverb.com/image/upload/v1641407740/fxltmj3h1glcpbrdejdn';

  const displayClassName = classNames(
    'sell-yours-v4',
    {
      'sell-yours-v4--below-listing': belowListing,
    },
  );

  return (
    <div className={displayClassName}>
      <div className="sell-yours-v4__container" style={{ backgroundImage: `url("${backgroundImage}")` }}>
        <div className="sell-yours-v4__content">
          <img
            src={USD}
            alt={I18n.t('discovery.sellYoursV4.altIconText')}
            className="sell-yours-v4__icon"
          />
          <div className="sell-yours-v4__text">
            <h3 className="sell-yours-v4__title">
              {I18n.t('discovery.sellYoursV4.title')}
            </h3>
            <span className="sell-yours-v4__copy">{I18n.t('discovery.sellYoursV4.copy')}</span>
          </div>
        </div>

        <CoreLink
          className="sell-yours-v4__button"
          to={prefilledListingFromCSP(id)}
          target="_blank"
          clickEvent={trackingData}
        >
          {I18n.t('discovery.sellYoursV4.button')}
        </CoreLink>
      </div>
    </div>
  );
}

export default SellYoursV4;
